
import React, { useState } from "react";
import {
  Button,
  Form,
  Image,
  Input,
  Select,
  Space,
  TimePicker,
  Upload,
} from "antd";

function SalonAddress({ form, onFinishCreateAddress, current, prev }) {

  return (
    <div className="Create-Category">
      {/* <h3>Create User</h3> */}
      <Form
        layout="vertical"
        className="subscription-form"
        form={form}
        onFinish={onFinishCreateAddress}
      >
        <div className="subscription">
          <Form.Item
            label="Address"
            name="address"
            className="subscription-plan"
            rules={[
              { required: true, message: "Please enter address" },
            ]}
          >
            <Input size="large" placeholder="Enter address" />
      
          </Form.Item>

          <Form.Item
            label="State"
            name="state"
            className="subscription-plan"
            rules={[
              { required: true, message: "Please select the state" },
              { pattern: /^[A-Za-z\s]+$/, message: "State can only contain alphabetic characters!" },
            ]}
          >
            <Input size="large" placeholder="Enter state" />
       
          </Form.Item>
        </div>

        <div className="subscription">
          <Form.Item
            label="District"
            name="district"
            className="subscription-plan"
            rules={[
              { required: true, message: "Please select the district" },
              { pattern: /^[A-Za-z\s]+$/, message: "District can only contain alphabetic characters!" },
            ]}
          >
            <Input size="large" placeholder="Enter district" />
          
          </Form.Item>

          <Form.Item
            label="City"
            name="city"
            className="subscription-plan"
            rules={[
              { required: true, message: "Please enter city name" },
              { pattern: /^[A-Za-z\s]+$/, message: "City name can only contain alphabetic characters!" },
            ]}
          >
            <Input size="large" placeholder="Enter city" />
          
          </Form.Item>
        </div>

        <div className="subscription">
          <Form.Item
            label="Near"
            name="nearBy"
            className="subscription-plan"
            rules={[
              {
                required: true,
                message: "Please enter near",
              },
            ]}
          >
            <Input size="large" placeholder="Enter near" />
          </Form.Item>

          <Form.Item
            label="Pincode"
            name="pincode"
            className="subscription-plan"
            rules={[
              { required: true, message: "Please enter the pincode" },
              { pattern: /^[0-9]{6}$/, message: "Pincode must be exactly 6 digits!" },
            ]}
          >
            <Input size="large" placeholder="Enter pincode" />
          </Form.Item>
        </div>

        <div className="subscription">
          <Form.Item
            label="Area"
            name="area"
            className="subscription-plan"
            rules={[
              {
                required: true,
                message: "Please enter area",
              },
            ]}
          >
            <Input size="large" placeholder="Enter area" />
          </Form.Item>

          <Form.Item
            label="Latitude"
            name="latitude"
            className="subscription-plan"
            rules={[
              { pattern: /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?|[0-9](\.\d+))$/, message: "Please enter a valid latitude!" },
            ]}
          >
            <Input size="large" placeholder="Enter latitude" />
          </Form.Item>
        </div>

        <div className="subscription">

          <Form.Item
            label="Longitude"
            name="longitude"
            className="subscription-plan"
            rules={[
              { pattern: /^-?((1[0-7][0-9])|([0-9]{1,2}))(\.\d+)?$/, message: "Please enter a valid longitude!" },
            ]}
          >
            <Input size="large" placeholder="Enter longitude" />
          </Form.Item>
        </div>

        <div className="steps-action">
          <Button type="primary" htmlType="submit">
            Next
          </Button>

        </div>

      </Form>
    </div>
  )
}

export default SalonAddress